import type { ReactNode } from "react";

export type DetailCollapseSectionProps = {
  sectionId: string;
  title: string;
  icon: ReactNode;
  count?: number;
  isOpen: boolean;
  onToggle: (id: string) => void;
  isRtl?: boolean;
  children: ReactNode;
};

const DetailCollapseSection = ({
  sectionId,
  title,
  icon,
  count,
  isOpen,
  onToggle,
  isRtl = false,
  children,
}: DetailCollapseSectionProps) => {
  const panelId = `detail-collapse-${sectionId}`;

  return (
    <section
      className={`ac-shop-detail__section${
        isOpen ? " ac-shop-detail__section--open" : ""
      }`}
    >
      <button
        type="button"
        className={`ac-shop-detail__collapse-btn${
          isOpen ? "" : " collapsed"
        }`}
        aria-expanded={isOpen}
        aria-controls={panelId}
        onClick={() => onToggle(sectionId)}
      >
        <span className="ac-shop-detail__collapse-heading">
          <span className="ac-shop-detail__collapse-icon" aria-hidden>
            {icon}
          </span>
          <span
            className={`ac-shop-detail__collapse-title${isRtl ? " ac--font-expo" : ""}`}
          >
            {title}
          </span>
        </span>
        {count != null && count > 0 ? (
          <span className="ac-shop-detail__section-count">{count}</span>
        ) : null}
        <span className="ac-shop-detail__collapse-chevron-wrap" aria-hidden>
          <svg
            className="ac-shop-detail__collapse-chevron"
            width="12"
            height="7"
            viewBox="0 0 12 7"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M1 1L6 6L11 1"
              stroke="currentColor"
              strokeWidth="1.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </span>
      </button>
      <div
        id={panelId}
        className={`ac-shop-detail__collapse-panel${
          isOpen ? " is-open" : ""
        }`}
        aria-hidden={!isOpen}
      >
        <div className="ac-shop-detail__collapse-inner">{children}</div>
      </div>
    </section>
  );
};

export default DetailCollapseSection;
